import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-category-list',
  templateUrl: './category-list.component.html',
  styleUrls: ['./category-list.component.scss']
})
export class CategoryListComponent implements OnInit {

  @Input() data: any;
  @Input() linkPath1: string = "programs";
  @Input() linkPath2: string;
  @Input() ariaItemLabel: string;

  constructor() { }

  ngOnInit() {
  }

}
